import React from 'react';
import './Reviews.css';
import Popup from '../Popup/Popup'
import Mehta from '../../img/reviews/Mehta.jpg'
import Andrei from '../../img/reviews/Andrei.jpg';
import Abraham from '../../img/reviews/Abraham.jpg';
import Shrestha from '../../img/reviews/Shrestha.jpg';
import stars from '../../img/main/stars.png';
import quotes from '../../img/reviews/quotes.svg';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default class Reviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [
        {
          id: 4,
          show: true,
          photo: Mehta,
          name: 'Madhav Mehta',
          title: `It was a great webinar, speakers were well informed and there was hands on practices which made it more interesting.It helped me to understand what is currently going on in this field as it is vast and there are new things happening everyday. Looking for more of such events in future!`,
        },
        {
          id: 2,
          show: true,
          photo: Andrei,
          name: 'Sergiu Andrei D.',
          title: `You are organizing an excellent summit, one which checks all that boxes that a great conference should: presentations that attract people from all experience levels, speakers that are experienced professionals who legitimize the summit and kickstart the networking process.`,
        },
        {
          id: 3,
          photo: Abraham,
          name: 'Ricardo German Abraham',
          title: `Very good conference about how it was moderated and how each time was respected to avoid any long presentation, it was great!`,
        },
        {
          id: 1,
          photo: Shrestha,
          name: 'Surya Man Shrestha',
          title: `It was awesome experience to attend the summit, hope this will be my turning point in the future of my career.`,
        },
      ]
    }
  }

  renderReviews(item, i) {
    return (
      <div className="reviews_item_wrap" key={`reviews_item-${i}`}>
        <div className='reviews_item'>
          <div className='reviews_item-content'>
            <img className='reviews_quotes' src={quotes} alt="" />
            {item.show && <div className='reviews_title'>
              {item.title.substring(0, 90)}...<Popup desc={item.title} title={item.name} key={i} />
            </div>}
            {!item.show && <div className='reviews_title'>
              {!item.show && <p>{item.title}</p>}
            </div>}
          </div>
          <div className='reviews_item-info'>
            <img className='reviews_photo' src={item.photo} alt="" />
            <div className="reviews_item_name_block">
              <p className="reviews_item_name">{item.name}</p>
              <img className="reviews_stars" src={stars} alt="" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="reviews black" id='reviews'>
        <div className='container reviews_wrap'>
          <h2>What <span className='title_gradient'>people</span> say</h2>
          <div className="review_block review_block--pc">
            {this.state.reviews.map((item, i) => this.renderReviews(item, i))}
          </div>
          <div className="review_block review_block--mob">
            <Carousel showThumbs={false} showStatus={false} swipeable emulateTouch infiniteLoop>
              {this.state.reviews.map((item, i) => this.renderReviews(item, i))}
            </Carousel>
          </div>
        </div>
      </div>
    )
  }
}